/**
 *
 * @param {string} name
 * @returns
 */

const url = `app`;
export const LOAD_RECORDS_VALID_CACHE = `${url}/LOAD_RECORDS_VALID_CACHE`;


export const LOAD_MASTER_DEPARTMENT = `${url}/LOAD_MASTER_DEPARTMENT`;
export const LOAD_MASTER_DEPARTMENT_SUCCESS = `${url}/LOAD_MASTER_DEPARTMENT_SUCCESS`;
export const LOAD_MASTER_DEPARTMENT_ERROR = `${url}/LOAD_MASTER_DEPARTMENT_ERROR`;

export const LOAD_MASTER_DESIGNATION = `${url}/LOAD_MASTER_DESIGNATION`;
export const LOAD_MASTER_DESIGNATION_SUCCESS = `${url}/LOAD_MASTER_DESIGNATION_SUCCESS`;
export const LOAD_MASTER_DESIGNATION_ERROR = `${url}/LOAD_MASTER_DESIGNATION_ERROR`;

export const LOAD_ROLE = `${url}/LOAD_ROLE`;
export const LOAD_ROLE_SUCCESS = `${url}/LOAD_ROLE_SUCCESS`;
export const LOAD_ROLE_ERROR = `${url}/LOAD_ROLE_ERROR`;

export const LOAD_LOGINSHIFTS = `${url}/LOAD_LOGINSHIFTS`;
export const LOAD_LOGINSHIFTS_SUCCESS = `${url}/LOAD_LOGINSHIFTS_SUCCESS`;
export const LOAD_LOGINSHIFTS_ERROR = `${url}/LOAD_LOGINSHIFTS_ERROR`;


export const LOAD_LOP_SETTING = `${url}/LOAD_LOP_SETTING`;
export const LOAD_LOP_SETTING_SUCCESS = `${url}/LOAD_LOP_SETTING_SUCCESS`;
export const LOAD_LOP_SETTING_ERROR = `${url}/LOAD_LOP_SETTING_ERROR`;

export const LOAD_MASTER_HOLIDAY = `${url}/LOAD_MASTER_HOLIDAY`;
export const LOAD_MASTER_HOLIDAY_SUCCESS = `${url}/LOAD_MASTER_HOLIDAY_SUCCESS`;
export const LOAD_MASTER_HOLIDAY_ERROR = `${url}/LOAD_MASTER_HOLIDAY_ERROR`;
const constants = {
  LOAD_MASTER_DEPARTMENT,
  LOAD_MASTER_DEPARTMENT_SUCCESS,
  LOAD_MASTER_DEPARTMENT_ERROR,
  LOAD_MASTER_DESIGNATION,
  LOAD_MASTER_DESIGNATION_SUCCESS,
  LOAD_MASTER_DESIGNATION_ERROR,
  LOAD_ROLE,
  LOAD_ROLE_SUCCESS,
  LOAD_ROLE_ERROR,
  LOAD_LOGINSHIFTS,
  LOAD_LOGINSHIFTS_SUCCESS,
  LOAD_LOGINSHIFTS_ERROR,
  LOAD_LOP_SETTING,
  LOAD_LOP_SETTING_SUCCESS,
  LOAD_LOP_SETTING_ERROR,
  LOAD_MASTER_HOLIDAY,
  LOAD_MASTER_HOLIDAY_SUCCESS,
  LOAD_MASTER_HOLIDAY_ERROR
}

export default constants;